import { deliveryEventLabel, deliveryEventTime } from './delivery-display';
import { useEffect, useState } from 'react';
import { deliverySummarySchema, type DeliverySummary } from '@sqi/shared-schemas';
import type { OemContext } from '../../lib/auth';
import { request } from '../../lib/oem-client';
import { retainOperationsMutation, settleOperationsMutation } from '../../lib/operations-pending';
export function DeliverySummaryPage({ context, userId }: { context: OemContext; userId: string }) {
  const [data, setData] = useState<DeliverySummary | null>(null),
    [message, setMessage] = useState('กำลังอ่านพัสดุที่แชร์');
  const refresh = async () => {
    setData(null);
    setData(deliverySummarySchema.parse(await request('/delivery/' + context.projectId)));
  };
  useEffect(() => {
    let active = true;
    void request('/delivery/' + context.projectId)
      .then((v) => {
        if (active) {
          setData(deliverySummarySchema.parse(v));
          setMessage('เฉพาะพัสดุของโครงการที่ผู้มีสิทธิ์แชร์แล้ว');
        }
      })
      .catch(() => {
        if (active) {
          setData(null);
          setMessage('ยังอ่านพัสดุไม่ได้');
        }
      });
    return () => {
      active = false;
    };
  }, [context.projectId]);
  async function received(parcelId: string) {
    const scope = {
      actorId: userId,
      organizationId: context.organizationId,
      projectId: context.projectId,
      action: 'customer_received:' + parcelId,
    };
    try {
      if (!navigator.onLine) throw Error('online_required');
      const idempotencyKey = await retainOperationsMutation(sessionStorage, scope, { parcelId });
      await request('/delivery/' + context.projectId + '/received', { parcelId, idempotencyKey });
      settleOperationsMutation(sessionStorage, scope, idempotencyKey);
      await refresh();
      setMessage('บันทึกรับพัสดุแล้ว · การยอมรับตัวอย่างเป็นอีกขั้นหนึ่ง');
    } catch {
      setMessage('ยังยืนยันผลรับไม่ได้ · ลองอีกครั้งเมื่อออนไลน์');
    }
  }
  return (
    <>
      <h1>ติดตามพัสดุที่แชร์</h1>
      <p role="status">{message}</p>
      <p>ขนส่งรายงานส่งถึง การรับพัสดุ และการยอมรับตัวอย่างเป็นคนละรายการ</p>
      <button
        className="action secondary"
        onClick={() => void refresh().catch(() => setMessage('ยังอ่านพัสดุไม่ได้'))}
      >
        โหลดข้อมูลอีกครั้ง
      </button>
      {data?.length === 0 ? <p>ยังไม่มีพัสดุที่แชร์ให้โครงการนี้</p> : null}
      {data?.map((p) => (
        <section className="card" key={p.id}>
          <h2>
            {p.carrier} · {p.tracking}
          </h2>
          <p>
            {p.quantity} ชิ้น · ฉบับ {p.sourceVersion}
          </p>
          <ul>
            {p.events.map((e, i) => (
              <li key={i}>
                {deliveryEventLabel(e.event)} · {deliveryEventTime(e.observedAt)}
              </li>
            ))}
          </ul>
          {context.audience === 'customer' &&
          p.events.some((e) => e.event === 'dispatched') &&
          !p.events.some((e) => e.event === 'customer_received') ? (
            <button className="action" onClick={() => void received(p.id)}>
              บันทึกว่ารับพัสดุแล้ว
            </button>
          ) : null}
        </section>
      ))}
    </>
  );
}
